/** Today's date in the browser's time zone, as YYYY-MM-DD (the value of a date input). */
export function localIsoDate(now: Date): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export type ConsentDate = { ok: true; capturedAt: Date } | { ok: false; error: string };

/**
 * When the consent was given, from the form's date. Today means now: noon today would be in the future
 * every morning, and the database refuses a consent time more than 5 minutes ahead of its clock (M6
 * trigger). An earlier day means noon local time on that day, so the date never shifts across a time zone.
 */
export function consentCapturedAt(date: string, now: Date): ConsentDate {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return { ok: false, error: 'Choose the date' };
  const today = localIsoDate(now);
  if (date > today) return { ok: false, error: 'The date cannot be in the future' };
  if (date === today) return { ok: true, capturedAt: now };
  const noon = new Date(`${date}T12:00:00`);
  if (Number.isNaN(noon.getTime())) return { ok: false, error: 'Choose the date' };
  return { ok: true, capturedAt: noon };
}
